module.exports = __webpack_public_path__ + "img/icon_sm_cylysh.e40988bd.png";